<template>
    <div class="session-item">
        <v-divider></v-divider>
        <div class="d-flex flex-column flex-md-row justify-space-between py-4">
            <div>
                <div class="title" v-text="date"></div>
                <div class="subtitle-1 mb-2" v-text="time"></div>
                <div class="d-flex flex-column flex-sm-row align-start align-sm-center mb-4">
                    <v-chip 
                        pill 
                        class="mr-sm-2 mb-2 mb-sm-0" 
                        color="grey lighten-4"
                        :to="tutorId ? `/${$i18n.locale}/student/tutor/profile/${tutorId}` : ''"
                    >
                        <v-avatar left>
                            <template v-if="photo">
                                <v-img :src="`${baseImageUrl}${photo}`"></v-img>
                            </template>
                            <template v-else>
                                <v-avatar color="grey lighten-2">
                                    <v-icon>mdi-account</v-icon>
                                </v-avatar>
                            </template>
                        </v-avatar> 
                        <span class="font-weight-medium" v-text="userName"></span>   
                                                
                    </v-chip>
                    <v-chip 
                        outlined 
                        small
                        color="primary"
                        v-text="subject"
                    ></v-chip>
                    <v-chip 
                            dark 
                            class="ml-2 mr-2 mt-2 mt-sm-0">
                                <v-icon left>mdi-currency-usd-circle</v-icon> {{ price }}
                        </v-chip> 
                </div>
                <v-card flat class="custom-radius mb-4" color="grey lighten-4" max-width="100%">
                    <div class="session-text pa-4 body-1 font-weight-medium" v-text="message"></div>
                </v-card>
                <div>
                    <v-btn 
                        text 
                        small 
                        color="primary"
                        v-if="files > 0"
                        @click="$emit('preview-documents')"
                    >
                        <v-icon left small>mdi-file</v-icon> {{ $t('PreviewDocuments') }}
                    </v-btn>
                </div>
            </div>
            <div>
                <slot name="actions"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'sessionItem',
        props: {
            photo: String,
            date: String,
            time: String,
            tutorId: Number,
            userName: String,
            subject: String,
            message: String,
            price: Number,
            files: {
                type: Number,
                default: 0
            }
        },
        computed: {
            ...mapGetters(['baseImageUrl'])
        }
    }
</script>

<style lang="scss" scoped>
.session-text{
    word-break: break-all;    
}
</style>